import { useContext } from "react";
import { createBdcContext } from "../context/createBdcContext";

const useCreateBdc = () => {
  return useContext(createBdcContext);
};

export default useCreateBdc;
